import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import UserService from "../services/UserService";
import AuthService from "../services/AuthService";

export default function StaffForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;
  const currentUser = AuthService.getCurrentUser(); // Dobijamo podatke o ulogovanom adminu

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    roles: ["ROLE_DOCTOR"],
    firstName: "",
    lastName: "",
    email: ""
  });

  const [loading, setLoading] = useState(isEditMode);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (isEditMode) {
      UserService.getUserById(id)
        .then(data => {
          setFormData({
            username: data.username,
            password: "",
            roles: data.roles || ["ROLE_DOCTOR"],
            firstName: data.firstName || "",
            lastName: data.lastName || "",
            email: data.email || ""
          });
          setLoading(false);
        })
        .catch(err => {
          console.error("Greška:", err);
          setMessage("Neuspešno učitavanje podataka.");
          setLoading(false);
        });
    }
  }, [id, isEditMode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleRoleChange = (e) => {
    setFormData(prev => ({ ...prev, roles: [e.target.value] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditMode) {
        await UserService.updateUser(id, formData);
      } else {
        await UserService.createUser(formData);
      }
      navigate("/staff");
    } catch (err) {
      setMessage("Greška: " + err.message);
    }
  };

  // Logika za onemogućavanje promene uloge
  // 1. Ako nije admin (mada je cela stranica verovatno zaštićena)
  // 2. Ako admin menja samog sebe (poredimo ID-eve)
  const isRoleChangeDisabled = isEditMode && (currentUser && currentUser.id === parseInt(id));

  // Provera da li treba prikazati dodatna polja (Ime, Prezime, Email)
  // Prikazujemo ih ako uloga NIJE ROLE_ADMIN
  const showExtraFields = !formData.roles.includes("ROLE_ADMIN");

  if (loading) return <div className="container mt-4 text-center">Učitavanje...</div>;

  return (
    <div className="container mt-4">
      <div className="card shadow-sm mx-auto" style={{ maxWidth: "500px" }}>
        <div className="card-header bg-primary text-white text-center">
          <h4 className="mb-0">{isEditMode ? "Izmena Osoblja" : "Novo Osoblje"}</h4>
        </div>
        <div className="card-body">
          {message && <div className="alert alert-danger">{message}</div>}
          
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label font-weight-bold">Korisničko Ime</label>
              <input
                type="text"
                name="username"
                className="form-control"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label font-weight-bold">
                {isEditMode ? "Nova Lozinka (prazno ako ne menjaš)" : "Lozinka"}
              </label>
              <input
                type="password"
                name="password"
                className="form-control"
                value={formData.password}
                onChange={handleChange}
                required={!isEditMode}
              />
            </div>

            <div className="mb-3">
              <label className="form-label font-weight-bold">Uloga</label>
              <select 
                className="form-select" 
                value={formData.roles[0]} 
                onChange={handleRoleChange}
                disabled={isRoleChangeDisabled} // Onemogućeno ako admin menja sebe
              >
                <option value="ROLE_DOCTOR">Doktor</option>
                <option value="ROLE_NURSE">Medicinska Sestra</option>
                <option value="ROLE_ADMIN">Administrator</option>
              </select>
              {isRoleChangeDisabled && (
                <small className="text-muted">Ne možete menjati sopstvenu ulogu.</small>
              )}
            </div>

            {/* PAMETNA FORMA: Uslovna polja */}
            {showExtraFields && (
              <div className="border-top pt-3 mt-3">
                <h6 className="text-muted mb-3">Lični podaci (Doktor/Sestra)</h6>
                <div className="mb-3">
                  <label className="form-label">Ime</label>
                  <input
                    type="text"
                    name="firstName"
                    className="form-control"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Prezime</label>
                  <input
                    type="text"
                    name="lastName"
                    className="form-control"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            )}

            <div className="d-flex justify-content-between mt-4">
              <button type="button" className="btn btn-outline-secondary" onClick={() => navigate("/staff")}>
                Otkaži
              </button>
              <button type="submit" className="btn btn-success px-4">
                {isEditMode ? "Sačuvaj" : "Kreiraj"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}